<template>
<article class="styl-std" ref="article">
    <mt-loadmore
    :bottom-method="getMore" 
    :bottom-all-loaded="allLoaded"
    :auto-fill="false"
    ref="loadmore">
        <section v-for="(item, idx) in sections" :key="idx">
            <h4 v-if="(item||{}).title"><i class="icon-title"></i>{{(item||{}).title}}</h4>
            <div class="paragraph" v-html="viewDoc(item)"></div>
        </section>
    </mt-loadmore>
</article>
</template>

<script>
import ajax from '@/api/ajax'
import global from '@/util/globalVar'
import { mapMutations } from 'vuex'
import { Indicator, Toast, Loadmore } from 'mint-ui'
import _ from 'lodash'
import { debug } from 'util';

export default {
    data () {
        return {
            style: 'sty-std',
            allLoaded: false,
            genLoader: null,
            sections: []
        }
    },
    components: {
        'load-more': Loadmore,
    },
    methods: {
        ...mapMutations({
            setTitle:'setTitle',
            setShowHeader:'setShowHeader',
		    setShowCustomer: "setShowCustomer",
            setShowFooter: "setShowFooter"
        }),
        viewDoc({ isMarkdown = false, content, markdown }= {}) {
            let html = content
            isMarkdown && (html = this.mk2html(markdown))               // 转换文档
            html && (html= this.filterHtml(content))                    // 过滤文档
            return html
        },
        mk2html (txt) {  // markdown文档转html
            let html = txt
            let regRules = [
                { // 匹配<a>标签
                    name: 'a',
                    reg: /\[[\s\S]*?\]\([\s\S]*?\)/g,
                    convert: ({url, title}) => `<a href='${url}' title='${title}'></a>`
                },
                { // 匹配<img>标签
                    name: 'img',
                    reg: /!\\[[^\\]]+\\]\\([^\\)]+\\)/g,
                    convert: ({url, title}) => `<img src='${url}' title='${title}'/>`
                },
                { // 匹配<h>标签
                    name: 'h',
                    reg: /^(#+)([^#]*)/g,
                    convert: ({step,txt}) => `<h${step}>${txt}</h${step}>`
                },
                { // 匹配<p>标签
                    name: 'p',
                    reg: /\n(&gt;|\\>)(.*)/g,
                    convert: ({txt}) => `<p>${txt}</p>`
                },
                { // 匹配<ul>标签
                    name: 'ul',
                    reg: /^[\\s]*[-\\*\\+] +(.*)/g,
                    convert: ({lis}) => `<ul>${lis.map(li => '<li>${li}</li>').join('')}</ul>`
                },
                { // 匹配<ol>标签
                    name: 'ol', reg: /^[\\s]*[0-9]+\\.(.*)/g,
                    convert:  ({lis}) => `<ol>${lis.map(li => '<li>${li}</li>').join('')}</ol>`
                },
                { // 匹配<hr>标签
                    name: 'hr',
                    reg: /\[.*\]\(.*\)/g,
                    convert: () => `<hr/>`
                },
            ]
            _(regRules).forEach( ({name, reg, convert}) => {
                if (name in ['a','img']) {                             // 处理 <a> <img> 标签
                     html = html.replace( reg, item => {
                        let url = item.match(/\(.*\)/)[0]
                        let title = item.match(/\[.*\]/)[0]
                        url && url.substring(1, url.length - 1)
                        title && title.substring(1, url.length - 1)
                        return convert({url, title})
                     })
                } else if (name in ['ul', 'ol']) {                     // 处理 <ul> <ol> 标签
                    let lis = html.replace(reg, item => {
                        html.replace(reg, lis => convert({lis}))
                    })
                } else if (name === 'h') {
                    let txt = html.match(reg)
                    if (txt) {
                        const step = txt.match('^(#+)').length
                        txt = substring(step)
                        html.replace(reg, convert({item, txt}))
                    }
                }
            })
            return html
        },
        filterHtml (txt) {
            let html = txt
            let regRules = [
                { // 过滤script, &nbsp;标签
                    name: 'remove',
                    reg: /<script.*?>.*?<\/script>|&nbsp;/g,
                    convert: () => ''
                },
                { // 合并<br>标签
                    name: 'br',
                    reg: /<br\s*?\/*?>/g,
                    convert: () => '<br/>'
                },
                { // 处理内联样式中的&quot;
                    name: 'style',
                    reg:/style=\".*?\"/g,
                    convert: _ => {
                        return _.replace('&quot;',';')
                    }
                },
                { // 给<img>标签加样式
                    name: 'img',
                    reg: /<img.*?(.*?)(.*?)>/g,
                    convert: style => `<img $2 ${style}/>`
                },
                { // 处理table中的内联样式;
                    name: 'table',
                    reg: /<table.*?style=\"(.*?)\">/g,
                    convert: _ => {
                        return _.replace(/width:(.*?);/, 'width:100%;')
                    }
                },
            ]
            regRules.forEach(({ name, reg, convert }) => {
                let style=''
                switch(name) {
                    case 'img':
                        style = `style="border-radius:.1rem; width:100%"`
                        html = html.replace(reg, convert(style))
                        break;
                    default:
                        html = html.replace(reg, convert)
                }
            })
            return html
        },
        async fetchAticle ({productCode}) {
            let result = []
            try {
                const notCache = this.$route.query.notCache === 'true'
                const {data:{code,result:data}} = await ajax.getProductDetail({
                    params:{
                        productCode,
                        ...( notCache ?  {
                            notCache: true,
                            timestap: Date.now()
                        } : {})
                    },
                    headers: {
                        ...(notCache ? {
                            'Cache-Control': 'no-cache'
                        } : {
                            'Cache-Control': 'max-age=1800'
                        })
                    }
                })
                if (code===0 && data && Array.isArray(data)) {
                    result = data
                }
            }catch(e) {
                Toast('请稍后再试！')
            }
            return result
        },
        getMore () {
            if (!this.genLoader) return
            const { done, value:lst } = this.genLoader.next()
            if (done) {
                this.allLoaded = true
            } else {
                this.sections.push(...lst)
                this.sections = this.sections.sort( (a,b) =>{
                    return (b||{}).sequence -(a|| {}).sequence
                })
            }
            this.$refs.loadmore.onBottomLoaded();
        },
        loadFirst ({elWrap, el}) {  //首次加载, 直至内容高度大于容器高度
            const self = this
            self.getMore()
            this.$nextTick(function() {
                if(el.offsetHeight <= elWrap.offsetHeight && !self.allLoaded) {
                    self.loadFirst({elWrap, el})
                } else {
                    elWrap.scrollTop = 0
                }
            })
        },
        * genLoadMore ({ data = [], size = 1 }) {
            const total = Math.ceil(data.length/size)
            for (let i=0; i<total; i++)
                yield data.length>0 && data.slice(i*size, (i+1)*size)
        },
    },
    created () {
        this.setTitle('快递产品查询')
        this.setShowFooter(false);
		this.setShowCustomer(true)
        const productCode = this.$route.params.productCode
        this.fetchAticle({productCode}).then( data => { // 数据请求一次，分页滚动显示
            this.genLoader =  this.genLoadMore({ data })
            const self = this
            const el = self.$refs.loadmore.$el
            const elWrap = self.$refs.article
            this.loadFirst({elWrap, el})
            elWrap.onscroll = (function() { // pc端滚动加载
                const fnScroll = elWrap.onscroll
                let beforeScrollTop = 0
                return function(e) {
                    fnScroll && fnScroll.call(this)
                    self.$nextTick(function() {
                        let isScrollDown = elWrap.scrollTop > beforeScrollTop
                        beforeScrollTop = elWrap.scrollTop
                        if (elWrap.offsetHeight + elWrap.scrollTop >= el.offsetHeight && isScrollDown) {
                            self.getMore()
                        }
                    })
                }
            })()
        })
    }
}
</script>

<style lang="scss" scoped>
    .styl-std {
        letter-spacing: 0;
        padding: 5.9%;
        font-family: PingFangSC-Regular;
        line-height: 1.5;
        overflow-y: scroll;
        overflow-x: hidden;
        height:100%;
        box-shadow: 0 .1rem 13px 5px rgba(0,0,0, .1);
    }
    h4 {
        font-size: .34rem;
        font-weight: bolder;
        padding: .5rem 0 .2rem 0;
    }
    ::-webkit-scrollbar {
        display: none;  
    }
</style>


// WEBPACK FOOTER //
// src/pages/product/detail/index.vue